import React from 'react'
import PropTypes from 'prop-types'
import { Title26, Eyebrow } from 'components/Typography'
import GA4 from 'utils/GA4'

import {
  WrapperLink,
  CardImg,
  CardMeta,
  CardMetaDivider,
  CardTitle,
  CardEyebrow,
} from './ArticleCard.style'

const ArticleCard = ({
  title,
  eyebrow,
  publishDate,
  url,
  image,
  villageSlug,
  introductionTitle,
}) => {
  return (
    <WrapperLink
      to={url}
      onClick={() =>
        GA4('carousel_related_articles_click', {
          headline: title,
          component_headline: introductionTitle,
          village_name: villageSlug,
        })
      }>
      <CardImg
        image={image?.portrait?.gatsbyImageData}
        alt={image?.altText || ''}
      />
      <CardMeta>
        <Eyebrow as={CardEyebrow}>
          {eyebrow || null}
          {eyebrow && publishDate && <CardMetaDivider>⬩</CardMetaDivider>}
          {publishDate || null}
        </Eyebrow>
        {title && <Title26 as={CardTitle}>{title}</Title26>}
      </CardMeta>
    </WrapperLink>
  )
}

ArticleCard.propTypes = {
  eyebrow: PropTypes.string,
  url: PropTypes.string.isRequired,
  publishDate: PropTypes.string,
  title: PropTypes.string,
  image: PropTypes.shape({
    headline: PropTypes.string,
    altText: PropTypes.string,
    landscape: PropTypes.shape({
      gatsbyImageData: PropTypes.shape({
        aspectRatio: PropTypes.number.isRequired,
        src: PropTypes.string.isRequired,
        srcSet: PropTypes.string.isRequired,
        srcSetWebp: PropTypes.string.isRequired,
        sizes: PropTypes.string.isRequired,
      }),
    }),
    portrait: PropTypes.shape({
      gatsbyImageData: PropTypes.shape({
        aspectRatio: PropTypes.number.isRequired,
        src: PropTypes.string.isRequired,
        srcSet: PropTypes.string.isRequired,
        srcSetWebp: PropTypes.string.isRequired,
        sizes: PropTypes.string.isRequired,
      }),
    }),
  }),
  villageSlug: PropTypes.string,
  introductionTitle: PropTypes.string,
}

ArticleCard.defaultProps = {
  eyebrow: '',
  publishDate: '',
  title: '',
  image: {},
  villageSlug: '',
  introductionTitle: '',
}

export default ArticleCard
